import { useAdminProfiles } from '@/hooks/useAdminDirectory'
import { AdminProfileList } from './AdminProfileList'
import { sectionStyle, sectionTitleStyle, pageTitleStyle, pageSubtitleStyle } from './adminListStyles'

export default function AdminStudents() {
  const { profiles, loading, updating, setAccountStatus } = useAdminProfiles()
  const students = profiles.filter(p => p.primaryRole === 'student')

  return (
    <div style={{ maxWidth: 900 }}>
      <div style={pageTitleStyle}>Students</div>
      <div style={pageSubtitleStyle}>
        Every student account on the platform, across every school and instructor.
      </div>

      <div style={sectionStyle}>
        <div style={sectionTitleStyle}>Students ({students.length})</div>
        <AdminProfileList profiles={students} loading={loading} updating={updating} onSetStatus={setAccountStatus} />
      </div>
    </div>
  )
}
